module.exports = __webpack_public_path__ + "img/IMG_1645_WoodMatted_MockedUp.7f5daf82.jpg";